<template>
  <v-layout style="width:100vw;height:100vh;">

    <header-bar>

    </header-bar>
    <babylon-panel
    id="MainPanel"
    @init=OnInit
    >
    </babylon-panel>

    <cube-navigator
    v-if = "useCubeNav"
    style="position:absolute;"
    :isActive = "navigatorActive"
    :babylonPanelIdentifier="'MainPanel'"
    v-on:initalized="OnNavigatorInit"
    v-on:envLoaded="OnEnvironmentLoaded"
    v-on:WaypointLoaded="OnWaypointLoaded"
    navigationMethod = "CUBE"
    :waypoints = FullWaypointList
    :waypoint = targetWaypoint
    :allowFloorMovement = "true"
    :resetRotationOnMove="activeFixture != null"
    :fixtureNavActive="false"
    :activeFixture="null"
    :targetTouchpoint="targetTouchpoint"
    />
    <sphere-navigator
    v-else
    style="position:absolute;"
    :babylonPanelIdentifier="'MainPanel'"
    :isActive = "navigatorActive"
    :waypoint = "targetWaypoint"
    :waypoints = CurrentStageData.waypoints
    v-on:initalized="OnNavigatorInit"
    v-on:LoadingWaypoint="OnWaypointBeginLoad"
    v-on:WaypointLoaded="OnWaypointLoaded"
    :waypointNavigation = "true"
    :targetTouchpoint="targetTouchpoint"
    />
    <fixture-navigator
      :fixture="activeFixture"
      :isActive="fixtureNavActive"
      v-on:ChangeWaypoint="SetTargetWaypoint"
    />
    <shopping-cart
    
    />



    <!--
    <event-tracker

    />
    -->
    <touchpoint-visualizer
      :touchpoints="CurrentStageData.touchpoints"
      :isActive="touchpointsActive"
      :babylonPanelIdentifier="'MainPanel'"
      v-on:onTouchpointChange="OnTouchpointSelected"
      :waypoint="activeWaypoint"
      v-on:onTouchpointNavigate="OnTouchpointNavigate"
    />
    <insight-popup-panel
      :touchpoint="insightTouchpoint"
      v-on:onCloseInsight="insightTouchpoint = null"
    />
    <navigation-bar
    style="position:absolute;"
    v-on:OnTouchpointTap="OnNavpointPress"
    v-on:OnWaypointTap="OnTapWaypoint"
    />

    <mowaentry
     style="position:absolute;"
     v-on:OnTouchpointTap="OnTouchpointNavigationPress"
    />

    <v-dialog v-model="showEndingMessage" max-width="500px">
      <v-card dark >
        <v-card-title>
          What's Next
        </v-card-title>
        <v-card-text>
          You have reached the end of the World Athletics Championships Collection gallery.
          <br/>
          More exhibits will be displayed in 2027.
          <br/>
          Please select one of the following three options:
        </v-card-text>
        <v-card-actions>
          <v-layout column>
            <v-row align="center" justify="center" no-gutters class="pb-1">
              <v-col cols="12">
                <v-btn tile color="#bafe6d" width="100%" @click="ReturnToChampRoom()">
                  <span style="color:black;">Return to Championship Room</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" no-gutters class="pb-1">
              <v-col cols="12">
                <v-btn tile color="#d0aaff" width="100%" @click="ReturnToOriginsTunnel()">
                  <span style="color:black;">Return to Origins Tunnel</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" no-gutters class="pb-1">
              <v-col cols="12">
                <v-btn tile color="#6de8f0" width="100%" @click="ReturnToEntranceHall()">
                  <span style="color:black;">Return to Entrance Hall</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isLoadingProduct">
      <v-layout column="" align-center justify-center>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
          <v-spacer style="height:40px"></v-spacer>
          <v-card class="title ma-4 pa-2" color="transparent" flat>
              Loading Product...
          </v-card>
      </v-layout>
    </v-overlay>
  </v-layout>
</template>

<script>

import BabylonPanel from '../../Babylon/Panels/BabylonPanel.vue'
import SphereNavigator from '../../Babylon/Navigators/SphereNavigator.vue'
import TouchpointVisualizer from '../../Babylon/Visualizers/TouchpointVisualizer.vue'
import InsightPopupPanel from '../../Insights/InsightPopupPanel.vue'
import FixtureNavigator from '../../Babylon/Navigators/FixtureNavigator.vue'
import ShoppingCart from '../../Babylon/Panels/ShoppingCart.vue'
import EventTracker from '../../Babylon/Panels/EventTracker.vue'
import HeaderBar from '../../waonly/HeaderBar.vue'
import NavigationBar from '../../waonly/NavigationBar.vue'
import CubeNavigator from '../../Babylon/Navigators/CubeNavigator.vue'
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import { mapMutations} from 'vuex'
import mowaentry from '../../waonly/MOWAEntry.vue'


  export default {
    name: 'StageEnvironment',
    components: {
      BabylonPanel,
      SphereNavigator,
      TouchpointVisualizer,
      InsightPopupPanel,
      FixtureNavigator,
      ShoppingCart,
      EventTracker,
      HeaderBar,
      NavigationBar,
      mowaentry,
      CubeNavigator
    },
    props: {
    },
    computed: {
      ...mapGetters("sessionState", [
        "GetBabPnl",
        "CurrentStageData"
        
      ]),
      ...mapState("sessionState", [
        "showMainLoadScreen",
        "showFadeout",
        "desiredWaypoint",
        "isProductFocused",
        "activeTourStep",
        "package",
        "forceShowTouchpoint"
      ]),

      FullWaypointList()
      {
        let fixtureWaypoints = [];

        if(this.CurrentStageData.planograms != null)
        {
          this.CurrentStageData.planograms.forEach(planogram => {
            fixtureWaypoints = fixtureWaypoints.concat(planogram.waypoints);
          });
        }

        return this.CurrentStageData.waypoints.concat(fixtureWaypoints);
      },
    },

    mounted: () => {

    },
    data: () => ({

      useCubeNav : true,
      navigatorActive : false,
      fixtureNavActive : false,
      touchpointsActive : false,
      activeWaypoint : null,
      insightTouchpoint : null,
      targetWaypoint : null,
      testMatrix : null,
      downPointerPos : null,
      lastFramePos : null,
      pointerDown : false,
      pointerDownTime : null,
      isPaning : false,
      isFocused : false,
      selectedProductData : null,
      focusedProduct : null,
      focusedCollider : null,
      productZoom : 0,
      productSpin : true,
      focusedXRotation : 0,
      focusedYRotation : 0,
      minProductDist : 0,
      maxProductDist : 0,
      zoomAmount : 0,
      isLoadingProduct : false,
      activeFixture : null,
      maxPOVZoom : 0.5,
      targetTouchpoint : null,
      showEndingMessage : false
    }),
    methods: {

      ...mapMutations("sessionState", [
        "SetMainLoadScreenState",
        "SetFadeoutState",
        "SetActiveWaypointid",
        "SetProductFocus",
        "SetFocusedProductData",
        "SetForceLandRotation",
        "SetHomeScreenVisibility",
        "SetDesiredWaypoint",
        "SetVideoGroups",
        "SetForceShowTouchpoint",
        "SetForceShowAsset"
      ]),

      ...mapMutations("trackedState", [
        "AddTrackedEvent"
      ]),

      OnEnvironmentLoaded()
      {

      },
      ReturnToChampRoom()
      {
        let targetWaypoint = this.CurrentStageData.waypoints.find(w => w.name == "CR_1983_A");
        this.SetForceLandRotation(true);
        this.targetWaypoint = targetWaypoint;
        this.showEndingMessage = false;
      },
      ReturnToOriginsTunnel()
      {
        let targetWaypoint = this.CurrentStageData.waypoints.find(w => w.name == "TUN_Entrance");
        this.SetForceLandRotation(true);
        this.targetWaypoint = targetWaypoint;
        this.showEndingMessage = false;
      },
      ReturnToEntranceHall()
      {
        let targetWaypoint = this.CurrentStageData.waypoints.find(w => w.name == "EH_Entrance In");
        this.SetForceLandRotation(true);
        this.targetWaypoint = targetWaypoint;
        this.showEndingMessage = false;
      },

      OnTapWaypoint(waypoint)
      {
        this.targetWaypoint = waypoint;
      },
      SetTargetWaypoint(waypoint)
      {
        this.targetWaypoint = waypoint;
      },

      OnInit()
      {
        this.navigatorActive = true;
        this.touchpointsActive = true;
        this.fixtureNavActive = true;
        this.CreateFixtureMatrixes();
        this.CreateClickableHandler();
        var inst = this.GetBabPnl("MainPanel");

        /*
        
        inst.scene.debugLayer.show({
          embedMode: false,
        });

        */
        

        if(this.package.videoScreens != null)
        {
          let videoGrpsArray = [];

          this.package.videoScreens.forEach(screen => {

            //Now we load touchpointScreens

            console.log("Loading video",screen.id);
            
            var mat = new BABYLON.StandardMaterial(screen.id + "_VideoTexture", inst.scene);
            //mat.emissiveColor = new BABYLON.Color3(1,1,1);
            mat.emissiveTexture = new BABYLON.VideoTexture(screen.id + "_Video", screen.videoUrl, inst.scene, false);
            mat.emissiveTexture.video.pause();

            console.log("Is looped?",screen);

            if(screen.looped != null)
            {
              mat.emissiveTexture.video.loop = screen.looped;
            }

            
            mat.disableLighting = true;
            mat.alpha = 0;

            BABYLON.SceneLoader.ImportMesh("",screen.modelUrl, "", inst.scene, (mesh,particleSystems,skeletons, animationsGroup) => {
              let newVideoScreen = {id : screen.id, waypoints : screen.waypoints, meshes : [], url : screen.videoUrl};
              mesh.forEach(innerMesh => {

                if(innerMesh.isPickable)
                {
                  if(innerMesh.name.includes(screen.id))
                  {
                    innerMesh.material = mat;
                  }

                  if(innerMesh.material != null)
                    newVideoScreen.meshes.push(innerMesh);
                }
              })

              videoGrpsArray.push(newVideoScreen);
            });
            


          })

          this.SetVideoGroups(videoGrpsArray);
        }
      },
      OnNavigatorInit()
      {
        var startingWaypoint = this.GetStartingWaypoint();

        if(startingWaypoint != null)
        {
          this.targetWaypoint = startingWaypoint;
        }

        this.AddTrackedEvent({

          type : "STARTSESSION"

        });

     

      },

      OnNavpointPress(navPoint)
      {
        if(navPoint.insightIndex != -1)
        {
          var touchpoint = this.CurrentStageData.touchpoints.find(e => e.id == navPoint.touchpointid);

          //Are there actually multiple assets for this touchpoint?
          if(touchpoint.typeData.assetDetailids != null && touchpoint.typeData.assetDetailids.length > 0 && navPoint.insightIndex < touchpoint.typeData.assetDetailids.length)
          {
            this.SetForceShowAsset(touchpoint.typeData.assetDetailids[navPoint.insightIndex])
          }
        }
        
        this.OnTouchpointNavigationPress(navPoint.touchpointid);
      },
      OnTouchpointNavigationPress(touchpointid)
      {
        var touchpointFilter = this.CurrentStageData.touchpoints.filter(e => e.id == touchpointid);
        if(touchpointFilter.length > 0)
        {
          this.OnTouchpointSelected(touchpointFilter[0],true);
        }

        if(this.forceShowTouchpoint)
        {
          this.insightTouchpoint = touchpointFilter[0];
          this.SetForceShowTouchpoint(false);
        }
      },
      OnTouchpointNavigate(touchpoint)
      {
        let waypoint = this.CurrentStageData.waypoints.find(wypn => wypn.id == touchpoint.targetWaypoint);

        if(waypoint != null)
        {
          this.SetForceLandRotation(true);
          this.targetWaypoint = waypoint;
        }
      },
      OnTouchpointSelected(touchpoint,isMap = false)
      {
        if(touchpoint.typeData.templateid == "WAEND")
        {
          this.showEndingMessage = true;
          return;
        }

        if(touchpoint.type == "INSIGHT")
        {
          this.targetTouchpoint = touchpoint;

          if(!isMap && !touchpoint.allowTeleport)
          {
            this.insightTouchpoint = touchpoint;
            return;
          }

          let closestDistance = 99999;
          let closestWaypoint = null;

          let currentPosition = new BABYLON.Vector3(touchpoint.pos.x,touchpoint.pos.y,touchpoint.pos.z);

          for (let i = 0; i < this.CurrentStageData.waypoints.length; i++) {
            const waypoint = this.CurrentStageData.waypoints[i];
            let comparePos = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);
            let distance = BABYLON.Vector3.Distance(comparePos,currentPosition);

            if(distance < closestDistance)
            {
              let dirVector = comparePos.subtract(currentPosition).normalize();
              let dotProd = BABYLON.Vector3.Dot(dirVector,new BABYLON.Vector3(touchpoint.dir.x,touchpoint.dir.y,touchpoint.dir.z));

              if(dotProd < 0.2)
              {
                continue;
              }

              closestDistance = distance;
              closestWaypoint = waypoint;
            }
          }

          if(closestWaypoint.id == this.activeWaypoint.id)
          {
            this.SetForceLandRotation(false);
            this.insightTouchpoint = touchpoint;
          }
          else
          {
            this.targetWaypoint = closestWaypoint;
            this.insightTouchpoint = touchpoint;
          }

          
        }
      },
      OnWaypointLoaded(newWaypoint)
      {
        this.targetTouchpoint = null;
        this.activeWaypoint = newWaypoint;
        this.targetWaypoint = newWaypoint;
        if(this.showMainLoadScreen)
        {
          this.SetMainLoadScreenState(false);
        }

        if(this.showFadeout)
        {
          this.SetFadeoutState(false);
        }

          
      },
      OnWaypointBeginLoad(newWaypoint)
      {
      
        if(!this.showMainLoadScreen)
        {
          this.SetFadeoutState(true);
        }
      },
      GetStartingWaypoint()
      {

        if(this.CurrentStageData.waypoints.length == 0)
        {

          var planogramsWithWaypoints = this.CurrentStageData.planograms.filter(e => e.waypoints.length > 0);
          this.activeFixture = planogramsWithWaypoints[0];
          return null;
        }
        else
        {
          var matchedWaypoints = this.CurrentStageData.waypoints.filter(e => e.id == this.desiredWaypoint);

          if(matchedWaypoints.length > 0)
          {
            return matchedWaypoints[0];
          }
          else
          {
            return this.CurrentStageData.waypoints[0];
          }
        }
      },
      CreateFixtureMatrixes()
      {
        if(this.CurrentStageData.planograms != null && this.CurrentStageData.planograms.length > 0)
        {
          var inst = this.GetBabPnl('MainPanel');
          var scene = inst.scene;
          var envData = this.CurrentStageData;
          
          var box2 = BABYLON.Mesh.CreateBox("box2", 1, scene);
          box2.position = new BABYLON.Vector3(envData.planograms[0].colInfo.pos.x,envData.planograms[0].colInfo.pos.y,envData.planograms[0].colInfo.pos.z); 
          box2.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(envData.planograms[0].colInfo.euler.x),BABYLON.Tools.ToRadians(envData.planograms[0].colInfo.euler.y),BABYLON.Tools.ToRadians(envData.planograms[0].colInfo.euler.z));
          var matBox2 = new BABYLON.StandardMaterial("matBox2", scene);
          matBox2.diffuseColor = new BABYLON.Color3(0.1, 0.1, 1);
          box2.material = matBox2;
          box2.scaling = new BABYLON.Vector3(envData.planograms[0].colInfo.size.x * 2,envData.planograms[0].colInfo.size.y * 2,envData.planograms[0].colInfo.size.z * 2);
          box2.isVisible = false;
          
          var matrix = box2.getBoundingInfo().boundingBox.getWorldMatrix();
          this.testMatrix = BABYLON.Matrix.Compose(new BABYLON.Vector3(1,1,1),new BABYLON.Quaternion.FromEulerAngles(box2.rotation.x,box2.rotation.y,box2.rotation.z),box2.position);
      
          var min = new BABYLON.Vector3(envData.planograms[0].lX, envData.planograms[0].lY, envData.planograms[0].lZ);
          var max = new BABYLON.Vector3(envData.planograms[0].mX, envData.planograms[0].mY, envData.planograms[0].mZ);
      
          var boundingBox = new BABYLON.BoundingBox(min,max,this.testMatrix);
        }
      },
      CreateClickableHandler()
      {
        var inst = this.GetBabPnl('MainPanel');
        var scene = inst.scene;

        scene.onPointerDown = (eventInfo, pickInfo, pointerEventType) => 
        {

            this.downPointerPos = new BABYLON.Vector2(scene.pointerX,scene.pointerY);
            this.lastFramePos = new BABYLON.Vector2(scene.pointerX,scene.pointerY);
            this.pointerDown = true;

            var frameTime = new Date();

            if(this.$data.pointerDownTime != null)
            {
                var dif = this.pointerDownTime.getTime() - frameTime.getTime();

                if(Math.abs(dif) < 500)
                {
                    //this.AddNewUserEvent({type : "PANINGPRODUCT", data :  ""});
                    this.isPaning = true;
                }
            }

            if(eventInfo.pointerType == "mouse")
            {
                if(eventInfo.button == 2)
                {
                    //this.AddNewUserEvent({type : "PANINGPRODUCT", data :  ""});
                    this.isPaning = true;
                }
            }

            this.pointerDownTime = new Date();
        };
        scene.onPointerUp = (eventInfo) => {

          var inst = this.GetBabPnl('MainPanel');
          var scene = inst.scene;
          var engine = inst.engine;
          var envData = this.CurrentStageData;

          this.isPaning = false;

          //if(this.$data.isLoading)
          //{
           //   return;
          //}

          let curPos = new BABYLON.Vector2(scene.pointerX,scene.pointerY);
          this.pointerDown = false;
          var dist = BABYLON.Vector2.Distance(curPos, this.downPointerPos);

          if(dist < 20)
          {
              if(this.isFocused)
              {
                  var pickResult = scene.pick(scene.pointerX, scene.pointerY);
                  if (pickResult.hit) {
                      
                  }
                  else
                  {
                      //this.AddNewUserEvent({type : "PUTDOWNPRODUCT", data :  this.$data.focusedProduct});
                      this.SetFocusState(false);
                  }
              }
              else
              {
                
                if(envData.planograms == null || envData.planograms.length == 0)
                  return;
                  
                var envData = this.CurrentStageData;
                var ray = new BABYLON.Ray(new BABYLON.Vector3(0,0,0), new BABYLON.Vector3(0,0,0), 100);
                var incrementor = 0;
                var raycastFromCam = scene.createPickingRay(scene.pointerX,scene.pointerY,BABYLON.Matrix.Identity(), scene.activeCamera);
                var hitinfo = this.GetAllHitsFromCollection(envData.planograms,raycastFromCam);

                if(hitinfo != null)
                {     
                  this.selectedProductData = hitinfo;

                 
                  //Clicked on product, so lets search our local database for its ref
                  var clickedProduct = envData.products.filter(product => product.id == hitinfo.refid)[0];

                  if(clickedProduct.glbUrl != null)
                  {
                      this.$options.focusedModel = hitinfo;
                      this.$data.isLoadingProduct = true;
                      //this.$data.loadingText = "Loading Product...";
                      this.focusedProduct = clickedProduct;

                      BABYLON.SceneLoader.ImportMesh("",clickedProduct.glbUrl, "", scene, (mesh,particleSystems,skeletons, animationsGroup) => {

                          var scaledRoot = false;
                          if(mesh[0].name != mesh[1].parent.name)
                          {
                              scaledRoot = true;
                          }
                          var boundingInfo = mesh[0].getBoundingInfo();
                          var min = boundingInfo.minimum.add(mesh[0].position);
                          var max = boundingInfo.maximum.add(mesh[0].position);
                          for (var i = 1; i < mesh.length; i++) {

                              if(mesh[i].parent.scaling.x != 1)
                              {
                                  mesh[i].parent = mesh[0];
                                  mesh[i].computeWorldMatrix(true);
                              }
                            
                              if(mesh[i].isPickable)
                              {
                                  boundingInfo = mesh[i].getBoundingInfo();
                                  min = BABYLON.Vector3.Minimize(min, boundingInfo.minimum.add(mesh[i].position));
                                  max = BABYLON.Vector3.Maximize(max, boundingInfo.maximum.add(mesh[i].position));
                              }
                          }

                          mesh[0].computeWorldMatrix(true);
                          mesh[0].rotation = new BABYLON.Vector3(0,0,0);
                          mesh[0].setBoundingInfo(new BABYLON.BoundingInfo(min, max));
                          //mesh[1].showBoundingBox = true;
                          mesh[0].setAbsolutePosition(new BABYLON.Vector3(hitinfo.colInfo.pos.x,hitinfo.colInfo.pos.y,hitinfo.colInfo.pos.z));

                          var sizeCurrent = 0;
                          var biggestMesh = null;

                          for (var i = 1; i < mesh.length; i++) {
                              if(sizeCurrent < mesh[i].getBoundingInfo().diagonalLength)
                              {
                                  sizeCurrent = mesh[i].getBoundingInfo().diagonalLength;
                                  biggestMesh = mesh[i];
                              }
                          }


                          var boundingInfo = biggestMesh.getBoundingInfo();
                          const bbCenterWorld = boundingInfo.boundingBox.centerWorld;
                          let focusedObj = null;
                          if(true)
                          {
                              var meshCenter = new BABYLON.TransformNode("root");
                              meshCenter.position = new BABYLON.Vector3(bbCenterWorld.x,bbCenterWorld.y,-bbCenterWorld.z);

                              mesh[0].parent = meshCenter;
                              mesh[0].setAbsolutePosition(new BABYLON.Vector3(0,0,0));
                              //mesh[1].setAbsolutePosition(absPos);
                              

                              focusedObj = meshCenter;
                              this.$options.focusedObj = meshCenter;
                          }
                          else
                          {
                              focusedObj = mesh[0];
                              this.$options.focusedObj = mesh[0];
                          }

                          focusedObj.position = new BABYLON.Vector3(hitinfo.colInfo.pos.x,hitinfo.colInfo.pos.y,hitinfo.colInfo.pos.z);
                          
                          var animationBox = new BABYLON.Animation("myAnimation", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);

                          var keys = []; 

                          keys.push({
                              frame: 0,
                              value: new BABYLON.Vector3(hitinfo.colInfo.pos.x,hitinfo.colInfo.pos.y,hitinfo.colInfo.pos.z)
                          });
                          
                          var size =  boundingInfo.boundingBox.extendSizeWorld;

                          var maxSize = size.x>size.z?size.x:size.z;
                          maxSize = maxSize.y>maxSize?maxSize.y:maxSize;
                          var ratio = engine.getAspectRatio(scene.activeCamera);
                          var h = maxSize / (Math.tan (1 / 2) * ratio) + 0.04;
                          this.$data.minProductDist = 0 + (boundingInfo.diagonalLength * 0.4);
                          this.$data.maxProductDist = h + (boundingInfo.diagonalLength * 0.8);
                          let centerPos = this.$data.minProductDist + (this.$data.maxProductDist - this.$data.minProductDist) * 0.5;

                          this.$data.productZoom = 0;

                          var tgtPosition = scene.activeCamera.getFrontPosition(this.$data.maxProductDist);//camera.getFrontPosition(0.40);

                          var cameraUpVector = scene.activeCamera.getDirection(scene.activeCamera.upVector);

                          this.$data.focusedCollider = hitinfo;
                          
                          keys.push({
                              frame: 20,
                              value: tgtPosition
                          });

                          animationBox.setKeys(keys);

                          focusedObj.animations = [];
                          focusedObj.animations.push(animationBox);

                          focusedObj.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;

                          scene.beginAnimation( focusedObj, 0, 100, false);

                          this.SetFocusState(true);
                          this.$data.isLoadingProduct = false;
                      });
                  }
                }
              }
          }
        }
        scene.onPointerMove = () => {

        if(this.isFocused)
        {
          if(this.pointerDown)
          {
              if(this.$data.isPaning)
              {
                  let horizontalInput = (this.lastFramePos.x - scene.pointerX) * 0.001;
                  let vertInput = (this.lastFramePos.y - scene.pointerY) * 0.001;

                  let cameraRight = scene.activeCamera.getDirection(new BABYLON.Vector3(1, 0, 0));
                  let cameraUp = scene.activeCamera.getDirection(new BABYLON.Vector3(0, 1, 0));

                  //cameraRight.add(cameraUp);
                  this.$options.focusedObj.translate(cameraRight,-horizontalInput,BABYLON.Space.WORLD);
                  this.$options.focusedObj.translate(cameraUp,vertInput,BABYLON.Space.WORLD);

                  cameraRight = cameraRight.scale(-horizontalInput);
                  cameraUp = cameraUp.scale(vertInput);

                  this.$options.panOffset = this.$options.panOffset.add(cameraRight);
                  this.$options.panOffset = this.$options.panOffset.add(cameraUp);
              }
              else
              {
                  this.$data.productSpin = false;
             
                  let rotationAmt = (this.lastFramePos.y - scene.pointerY) * 0.01;
                  
                  this.$options.focusedObj.rotate(BABYLON.Axis.X, rotationAmt, BABYLON.Space.WORLD)
                  var eulerRot = this.$options.focusedObj.rotationQuaternion.toEulerAngles();

                  this.$data.focusedXRotation += (this.lastFramePos.y - scene.pointerY) * 0.01;

                  if(Math.abs(this.$data.focusedXRotation) > 1)
                  {
                      this.$options.focusedObj.rotate(BABYLON.Axis.X, -(this.lastFramePos.y - scene.pointerY) * 0.01, BABYLON.Space.WORLD)
                      this.$data.focusedXRotation -= (this.lastFramePos.y - scene.pointerY) * 0.01;
                  }
                  
                  
                  this.$options.focusedObj.rotate(BABYLON.Axis.Y, (this.lastFramePos.x - scene.pointerX) * 0.01, BABYLON.Space.LOCAL);

                  this.$data.focusedYRotation += (this.lastFramePos.x - scene.pointerX) * 0.01;
                  if(Math.abs(this.$data.focusedYRotation) > 1)
                  {
                      if(this.$data.focusedProduct.rotationEvent == null)
                      {
                        this.AddTrackedEvent({

                          type : "PRODUCTROTATED",
                          key :  this.focusedProduct.idf
                        });

                        //this.AddNewUserEvent({type : "ROTATEPRODUCT", data :  this.$data.focusedProduct});
                        this.$data.focusedProduct.rotationEvent = true;
                      }
                  }

                  if(Math.abs(this.$data.focusedYRotation) > 1.7)
                  {
                      if(this.$data.focusedProduct.backSeenEvent == null)
                      {
                         this.AddTrackedEvent({

                          type : "PRODUCTSEENBACK",
                          key :  this.focusedProduct.idf
                        });

                          //this.AddNewUserEvent({type : "SEENPRODUCTBACK", data :  this.$data.focusedProduct});
                          this.$data.focusedProduct.backSeenEvent = true;
                      }
                  }

                  //box2.rotate(BABYLON.Axis.X, (lastFramePos.y - scene.pointerY) * 0.01, BABYLON.Space.LOCAL);
              }
              this.lastFramePos = new BABYLON.Vector2(scene.pointerX,scene.pointerY);
          }
        }
      };
     
        scene.onPrePointerObservable.add( (pointerInfo, eventState) => {
          var event = pointerInfo.event;
          var delta = 0;
          var inst = this.GetBabPnl('MainPanel');
          var scene = inst.scene;

          if (event.wheelDelta) {
              delta = event.wheelDelta;
          }
          else if (event.detail) {

              delta = -event.detail;
          }
          else if (event.deltaY)
          {
              delta = event.deltaY * -40;
          }
          if (delta) {

              if(this.$data.isFocused)
              {
                  if(this.$options.focusedObj != null)
                  {
                      this.$data.productZoom += delta/4000;

                      if(this.$data.productZoom < 0)
                      {
                          this.$data.productZoom = 0;
                      }
                      else if (this.$data.productZoom > 1)
                      {
                          this.$data.productZoom = 1;
                      }

                      if(this.$options.focusedObj.lookedClosed == null)
                      {
                        if(this.$data.productZoom > 0.5)
                        {
                          this.AddTrackedEvent({

                            type : "PRODUCTDETAILEDLOOK",
                            key :  this.focusedProduct.idf
                          });

                          this.$options.focusedObj.lookedClosed = true;
                        }
                      }

                      let vec = scene.activeCamera.getFrontPosition(this.$data.maxProductDist + (this.$data.minProductDist - this.$data.maxProductDist) * this.$data.productZoom);
                      var cameraUpVector = scene.activeCamera.getDirection(scene.activeCamera.upVector);

                      vec = vec.add(this.$options.panOffset);


                      this.$options.focusedObj.position = vec;
                  }
              }
              else
              {
                  scene.activeCamera.fov -= delta/4000;

                  if(scene.activeCamera.fov > 1)
                  {
                      scene.activeCamera.fov = 1;
                  }
                  else if (scene.activeCamera.fov <  this.$data.maxPOVZoom)
                  {
                      scene.activeCamera.fov = this.$data.maxPOVZoom;
                  }
              }

              this.$data.zoomAmount = scene.activeCamera.fov;
          }
      }, BABYLON.PointerEventTypes.POINTERWHEEL, false);
     },
      SetFocusState(isFocused)
      {
        var inst = this.GetBabPnl('MainPanel');
        var scene = inst.scene;
        this.SetProductFocus(isFocused);
        if(isFocused)
        {
          this.AddTrackedEvent({

            type : "PRODUCTPICKUP",
            key : this.focusedProduct.idf
          });

          this.$data.focusedProduct.rotationEvent = null;

          this.$options.panOffset = new BABYLON.Vector3(0, 0, 0); 

          /*
          var left = this.$options.scene.getMeshByName("Left");
          var right = this.$options.scene.getMeshByName("Right");
          left.material.alpha = 0.4;
          right.material.alpha = 0.4;
          */

          //this.ChangeZoomToPercent(0,true);

          scene.activeCamera.fov = 1;
          this.$data.focusedYRotation = 0;
          this.$data.focusedXRotation = 0;

          //this.AddNewUserEvent({type : "PICKUPPRODUCT", data :  this.$data.focusedProduct});

          this.$options.lastFramePos = new BABYLON.Vector2(scene.pointerX,scene.pointerY);
          scene.activeCamera.detachControl(inst.canvas);
        }
        else
        {
          /*
            var left = this.$options.scene.getMeshByName("Left");
            var right = this.$options.scene.getMeshByName("Right");
            left.material.alpha = 1;
            right.material.alpha = 1;
            */

            this.$data.focusedProduct = null;

            scene.activeCamera.attachControl(inst.canvas, true);

            if(this.$options.focusedObj != null)
            {
                this.$options.focusedObj.dispose();
                this.$options.focusedObj = null;
            }

         
        }

        this.isFocused = isFocused;
      },
      GetAllHitsFromCollection(listOfElements, ray)
      {
          let iterationNum = listOfElements.length;
          let hititem = null;
          let hitArray = new Array();

          for(let i = 0; i < iterationNum; i++)
          {
              //Foreach item in this array, if it has children lets check inside there
              if(this.IsElementHitByRay(listOfElements[i],ray)) //If child element is hit, lets go check the child items
              {
                  if(listOfElements[i].parts != null)
                  {
                      let hitChildrenArray = this.CheckElementLevel(listOfElements[i].parts,ray);

                      for (let t = 0; t < hitChildrenArray.length; t++) {

                          if(this.IsElementClickable(hitChildrenArray[t]))
                          {
                              hitArray.push(hitChildrenArray[t]);
                          }
                      }
                  }

                  if(this.IsElementClickable(listOfElements[i]))
                  {
                      hitArray.push(listOfElements[i]);
                  }
              }
          }

          if(hitArray.length > 0)
          {
              let closestItem;
              let closestDistance = 99999999;

              for(let d = 0; d < hitArray.length; d++)
              { 
                  var distanceVec = Math.abs(BABYLON.Vector3.Distance(ray.origin, new BABYLON.Vector3(hitArray[d].colInfo.pos.x,hitArray[d].colInfo.pos.y,hitArray[d].colInfo.pos.z)));

                  if(distanceVec < closestDistance)
                  {
                      closestDistance = distanceVec;
                      closestItem = hitArray[d];
                  }
              }

              hititem = closestItem;
          }

          return hititem;
      },
      IsElementHitByRay(element, parentRay)
      {
        if(element.bounds == null)
        {   
            if(element.colInfo.tag == "FACING" || element.colInfo.tag == "Facing")
            {
                //Debug box spawning
                if(false)
                {
                  var inst = this.GetBabPnl('MainPanel');
                  var scene = inst.scene;
                  let box = BABYLON.Mesh.CreateBox("box", 1, scene);

                  box.position = new BABYLON.Vector3(element.colInfo.pos.x,element.colInfo.pos.y,element.colInfo.pos.z); 
                  box.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(element.colInfo.euler.x),BABYLON.Tools.ToRadians(element.colInfo.euler.y),BABYLON.Tools.ToRadians(element.colInfo.euler.z));
                  box.scaling = new BABYLON.Vector3(element.colInfo.size.x * 2,element.colInfo.size.y * 2,element.colInfo.size.z * 2);

                  let boxmat = new BABYLON.StandardMaterial("testmat-" + element.refid , scene);
                  boxmat.diffuseColor = new BABYLON.Color3(Math.random(), Math.random(), Math.random());
                  box.material = boxmat;
                }
                //-----------------
            }
        
            let matrix = BABYLON.Matrix.Compose(new BABYLON.Vector3(1,1,1),new BABYLON.Quaternion.FromEulerAngles(BABYLON.Tools.ToRadians(element.colInfo.euler.x),BABYLON.Tools.ToRadians(element.colInfo.euler.y),BABYLON.Tools.ToRadians(element.colInfo.euler.z)),new BABYLON.Vector3(element.colInfo.pos.x,element.colInfo.pos.y,element.colInfo.pos.z));              

            let min = new BABYLON.Vector3(-element.colInfo.size.x, -element.colInfo.size.y, -element.colInfo.size.z);
            let max = new BABYLON.Vector3(element.colInfo.size.x, element.colInfo.size.y, element.colInfo.size.z);

            element.bounds = new BABYLON.BoundingBox(min,max,this.testMatrix);
            element.matrix = matrix;
          }

          var ray = new BABYLON.Ray(new BABYLON.Vector3(0,0,0), new BABYLON.Vector3(0,0,0), 100);

          BABYLON.Ray.TransformToRef(parentRay, BABYLON.Matrix.Invert(element.matrix),ray);
          return ray.intersectsBox(element.bounds);
      },
      CheckElementLevel(listOfElements, ray)
      {
          let iterationNum = listOfElements.length;
          let hitArray = new Array();

          for(let i = 0; i < iterationNum; i++)
          {
              if(this.IsElementHitByRay(listOfElements[i],ray)) //If child element is hit, lets go check the child items
              {
                  if(listOfElements[i].parts != null)
                  {
                      let hitChildrenArray = this.CheckElementLevel(listOfElements[i].parts,ray);

                      for (let t = 0; t < hitChildrenArray.length; t++) {
                          hitArray.push(hitChildrenArray[t]);
                      }
                  }

                  hitArray.push(listOfElements[i]);
              }
          }
      
          return hitArray;
      },
      IsElementClickable(element)
      {
          if(element.colInfo.tag == "Block" )
          {
              if(element.parts == null)
              {
                  return true;
              }
              else
              {
                  return false;
              }
          }
          else if (element.colInfo.tag == "Facing")
          {   
              return true;
          }
          else if (element.colInfo.tag == "FACING")
          {
              return true;
          }

          return false;
      },
      OnLinearNavigation(isNext)
      {

      }
    
    },
    watch: {

      activeTourStep : {
        handler(newVal)
        {
          if(newVal != null)
          {
            if(newVal.touchpointid != "")
            {
              var touchpoint = this.CurrentStageData.touchpoints.find(e => e.id == newVal.touchpointid);

              //Are there actually multiple assets for this touchpoint?
              if(touchpoint.typeData.assetDetailids != null && touchpoint.typeData.assetDetailids.length > 0 && newVal.touchpointIndex < touchpoint.typeData.assetDetailids.length)
              {
                this.SetForceShowAsset(touchpoint.typeData.assetDetailids[newVal.touchpointIndex])
              }

              this.OnTouchpointNavigationPress(newVal.touchpointid);
            }
            else if (newVal.waypointid != "")
            {
              this.targetTouchpoint = null;
              let foundWaypoint = this.CurrentStageData.waypoints.find(w => w.id == newVal.waypointid);

              if(foundWaypoint != null)
              {
                this.targetWaypoint = foundWaypoint;
              }
            }
          }
          else
          {
            this.SetForceLandRotation(true);
            this.targetTouchpoint = null;
            this.targetWaypoint = this.CurrentStageData.waypoints[0];
            this.SetHomeScreenVisibility(true);
          }
        }
      },
      CurrentStageData : {

        handler(newVal)
        {
          this.targetWaypoint = this.GetStartingWaypoint();
        }

      },
      desiredWaypoint : {

        handler(newVal)
        {

          if(newVal != null)
          {
            this.targetWaypoint = newVal;
            this.SetForceLandRotation(true);
            this.SetDesiredWaypoint(null);
          }
        }
      },
      activeWaypoint : {

        handler(newVal)
        {
          this.SetActiveWaypointid(newVal.id);
        }
      },
      isProductFocused : {

        handler(newVal)
        {
          if(this.isFocused != newVal)
          {
            this.SetFocusState(newVal);
          }
        }
      },
      focusedProduct : {
        handler(newVal)
        {
          this.SetFocusedProductData(this.focusedProduct);
        }
      }
    },
    beforeRouteUpdate (to, from, next) {

        this.SetMainLoadScreenState(true);
        next();
    },
  }
</script>
